<template>
    <div>
        <!-- <h1>{{ $t('betalingsmuligheder')}}</h1> -->
        <h1>{{ $t('betalingean') }}</h1>
        
        <!-- Vis 'loading' ikon mens API data loader... -->
        <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="">

        <div class="form">
            <div class="formColumn">

                <!-- EAN nr -->
                <input type="text" v-model="EANData.nummer" name="nummer" :placeholder="$t('EANnummer')"          style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="!EANData.nummer && submit==1" class="error">{{ $t('mangler')}} {{$t('EANnummer')}}</span>

                <!-- EAN myndighed -->
                <input type="text" v-model="EANData.myndighed" name="myndighed" :placeholder="$t('EANmyndighed')" style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="!EANData.myndighed && submit==1" class="error">{{ $t('mangler')}} {{$t('EANmyndighed')}}</span><br />

                <!-- EAN reference -->
                <input type="text" v-model="EANData.reference" name="reference" :placeholder="$t('EANreference')" style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="!EANData.reference && submit==1" class="error">{{ $t('mangler')}} {{$t('EANreference')}}</span><br />
            </div>
    
        </div>

    <div class="buttonContainer">

        <router-link to="betaling">
            <div class="continueButton">
                <!-- <a>{{ $t('videre')}}</a> -->
                <a>&laquo; {{$t('tilbage')}}</a>
            </div>
        </router-link>

        <a style="cursor: pointer;">
        <div v-on:click="storeCustomerData(EANData)" v-if="EANData.nummer && EANData.myndighed && EANData.reference" class="continueButton">
            <a>{{ $t('videre') }} &raquo;</a>
        </div>
        

        <div v-else class="continueButton" style="opacity: 0.2;">
            <a>{{ $t('videre') }} &raquo;</a>
        </div>
        </a>
        

    </div>


    </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data() {
        return {
            locale: i18n.locale,
            apiLoaded: 0,
            EANData: {},
            submit: 0,
        };
    },
    created() {
        //this.buildRequest();
        this.$store.dispatch("getPaymentPriceData", {
            'koncern': this.$route.params.koncern,
            'hotel': this.$store.getters.bookingInProgress.hotel,
            'paymentType': 'bankxfer'
        }).then(() => {this.apiLoaded = 1});
    },
    methods: {
        /**
         * - Gemmer EAN data i Vuex
         * - Opretter et referencenummer
         * - Videresender brugeren til fakturagenerering
         */
        storeCustomerData(data) {
          this.submit=1; // Så vi kun viser fejl hvis der er forsøgt at trykke "videre"

          if(!data.nummer) {
              console.log("EANnummer er ikke udfyldt...");
          }
          if (!data.myndighed) {
              console.log("EANmyndighed er ikke udfyldt...");
          }
          if (!data.reference) {
              console.log("EANreference er ikke udfyldt...");
          }
          if (data.nummer && data.myndighed && data.reference) {
              console.log('Alle data tilstede - gemmer data...');
              this.$store.dispatch("addEanData", data).then(
                () => this.$store.dispatch("getRefNo", {'koncern': this.$route.params.koncern, 'postnr': this.$store.getters.bookingInProgress.hotel}).then(
                    () => { this.$router.push({ path: '/'+this.locale+'/'+this.$route.params.koncern+'/faktura/'+this.$store.getters.refNo.refNo+'/initial/e' }) }
                ))
          }
      },
        
    }
}
</script>

<style scoped>
h1 {
  font-size: 400%;
  margin-bottom: 120px;
  font-weight: normal;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

/* Giver de enkelte input-elementer styling, hvid border, transparent baggrund og padding */
.form input[type="text"], [type="checkbox"], textarea {
    background: transparent;
    border: 2px solid white;
    padding: 5px;
    color: white;
}

/* Flex container, angiver hvordan den skal opføre sig ved smallere viewport */
.form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
}

.formColumn {
    flex: 0 0 10%;
    padding: 5px;
}

::placeholder {
    color: white;
    opacity: 1;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  flex: 0 0 100%;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}


@media screen and (max-width: 959px) {
    .paymentContainer {
        display: flex;
        flex-direction: column;
    }

    /* Mindre overskrift */
    h1 {
        font-size: 200%;
        margin-bottom: 20px;
    }
}


</style>